import { Fade } from "react-reveal"
import { useTranslation } from "react-i18next"
import React, { useState } from 'react';

const AboutUs = () => {
  const { t } = useTranslation()

  return (
    <>
      <section className="about-two pt-50 rpt-50 pb-50 rpb-10">
        <div className="container">
          <div className="about-wrap rounded-3">
            <div className="row">
              <div className="col-12 col-lg-6 align-self-center animation-left">
                <div className="about-content ps-md-4 pr-70 rpr-0 text-center text-md-start">
                  <div className="section-title mb-35">
                    <span className="sub-title">{t('about_title')}</span>
                    <h2>{t('about_subtitle')}</h2>
                  </div>
                  <p dangerouslySetInnerHTML={{ __html: t('about_text') }} ></p>
                </div>
              </div>
              <div className="col-12 col-lg-6 about-placeholder">
                <Fade right delay={300}>
                  <div className="p-md-3 mt-0 mt-md-3" style={{ top: "0%", right: "10%" }}>
                    <img src="/images/service/about-us-section.webp" alt="About" />
                  </div>
                </Fade>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
export default AboutUs